import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid2';
import NewsPost from '../../../../types/communication/newsPost';

const LatestNews = (): JSX.Element => {

  const theme = useTheme();
  const [newsPosts,setNewsPosts] = useState<NewsPost[]>();

  useEffect(() => {
    getNewsPosts();
  }, []);

  const getNewsPosts = async () => {
    try{
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/news/recent`)
      .then(result => result.json())
      .then(result => {
        let newsPosts: NewsPost[] = [];
        result.forEach((newsPost: NewsPost) => {
          newsPosts.push(prepareNewsPost(newsPost));
        });
        setNewsPosts(newsPosts);
      });

    }catch(error){
      console.error('Uncaught Error:', error);
    }
    
  }

  const prepareNewsPost = (newsPost: NewsPost) => {
   
    let postContent = newsPost.content;

    let regex = /<img.*?src="(.*?)"[^>]+>/g;
    let imageSrc = '';

    let regex_video = /<iframe.*?src="(.*?)"[^>]+>/g;
    let videoSrc = '';

    let regex_image_link = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/;
    let imgLink = '';

    if (postContent.indexOf('<img') > 0) {
        const match = regex.exec(postContent);
        if (match) {
            imageSrc = match[1];
        }
    }
    if (postContent.indexOf('<iframe') > 0) {
      const match = regex_video.exec(postContent);
      if (match) {
          videoSrc = match[1];
      }
    }
    if (postContent.indexOf('<a') > 0) {
      const match = regex_image_link.exec(postContent);
      if (match) {
          imgLink = match[2];
      }
    }
    newsPost.imageSrc = imageSrc;
    newsPost.videoSrc = videoSrc;
    newsPost.imageLink = imgLink;

    const firstParagraphStart = postContent.indexOf("<p>");
    const firstParagraphEnd = postContent.indexOf("<br>\n");
    const firstParagraph = postContent.substring(firstParagraphStart, firstParagraphEnd+5);

    postContent = postContent.replace(firstParagraph, '')
    
    //.replace(/<[^>]*>?/gm, '');;
  
    //const firstSentenceEnd = postContent.indexOf(".");
    //newsPost.contentHtml = postContent.substring(0, firstSentenceEnd+1);

    const secondParagraphEnd = postContent.indexOf("<br>");

    newsPost.contentHtml = postContent.substring(0, secondParagraphEnd-1);

    return newsPost;
  }

  return (
    <Box>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        flexDirection={{ xs: 'column', sm: 'row' }}
        marginBottom={4}
      >
        <Box>
          <Typography fontWeight={700} variant={'h6'} gutterBottom>
            Latest News
          </Typography>
        </Box>
        <Box display="flex" marginTop={{ xs: 2, md: 0 }}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            component={Link}
            href="/Publications/News"
          >
            View all
          </Button>
        </Box>
      </Box>
      <Grid container spacing={4}>
        {newsPosts?.map((item, i) => (
          <Grid size={12} key={i}>
            <Box
              component={Card}
              width={1}
              height={1}
              borderRadius={0}
              boxShadow={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Box
                sx={{
                  width: { xs: 1, md: '50%' },
                }}
              >
                {
                  item.imageSrc &&
                  <Box
                    className = "is-clickable"
                    component={'img'}
                    loading="lazy"
                    height={1}
                    width={1}
                    onClick={() => window.open(item.imageLink, '_blank')}
                    src={item.imageSrc}
                    alt="news image"
                    sx={{
                      objectFit: 'cover',
                      maxHeight: 250,
                      borderRadius: 2,
                    }}
                  />
                }
                {
                  item.videoSrc &&
                  <Box
                    className = "is-clickable"
                    height={1}
                    width={1}
                    sx={{
                      objectFit: 'cover',
                      height: 250,
                      borderRadius: 2,
                    }}
                  >
                     <iframe 
                        height={"100%"}
                        width={"100%"}
                        src={item.videoSrc} 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
                      </iframe>
                  </Box>
                }
               
              </Box>
              <CardContent
                className='is-clickable'
                //component={Link}
                //underline='none'
                onClick={() => {
                  window.location.href = `/Publications/News#news-${item.id}`;
                }}
                //href={`/Publications/News#news-${item.id}`}
                sx={{
                  width: { xs: 1, md: '50%' },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  "&:hover": {
                    backgroundColor: theme.palette.alternate.main,
                    boxShadow: 2,
                  },
                }}
              >
                <Typography
                  fontWeight={700}
                  color="black"
                  marginTop={1}
                  component={Link}
                  href={`/Publications/News#news-${item.id}`}
                  underline='hover'
                >
                  {item.title}
                </Typography>
                <Box marginY={1}>
                  <Typography
                    fontWeight={600}
                    variant={'body2'}
                    color={'primary'}
                    component={'i'}
                  >
                    {item.dateDisplayDay} {item.dateDisplayMonth} {item.dateDisplayYear}
                  </Typography>
                </Box>
                <Typography color="text.secondary">
                  <span dangerouslySetInnerHTML={{ __html: item.contentHtml }}></span>
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LatestNews;
